import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import agendaCoordinatorMessagesTpl from '../agendas/messages/agenda.coordinator.messages.html';
import agendaDateMessagesTpl from '../agendas/messages/agenda.date.messages.html';
import agendaNameMessagesTpl from '../agendas/messages/agenda.name.messages.html';
import agendaTypeMessageTpl from '../agendas/messages/agenda-type.messages.html';
import validator, { name as validatorName } from '../agendas/messages/agenda-unique-name.validator.directive';
import controller from './edit-agenda-dialog.controller';
import template from './edit-agenda-dialog.html';

class dialogService {
  getOptions($event, {
    agenda, agendaTypes, coordinators, refreshAgenda
  }) {
    return {
      controller,
      controllerAs: 'editAgendaDialogVM',
      locals: {
        agenda,
        agendaTypes,
        coordinators,
        refreshAgenda
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.oversight.editAgendaDialog', [
  alerts,
  oversightDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editAgendaDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('agenda-type.messages.html', agendaTypeMessageTpl);
    $templateCache.put('agenda.name.messages.html', agendaNameMessagesTpl);
    $templateCache.put('agenda.coordinator.messages.html', agendaCoordinatorMessagesTpl);
    $templateCache.put('agenda.date.messages.html', agendaDateMessagesTpl);
  })
  .name;
